import DecodingClient from '../../api/clients/reading/DecodingClient';
import DecodeClient from '../../api/clients/reading/DecodeClient';
import RANClient from '../../api/clients/reading/RANClient';
import MAZEClient from '../../api/clients/reading/MAZEClient';
import D8TranslatorClient from '../../api/clients/reading/TranslatorClient';
import sharedGetClient from '../shared/formsUtils';
import { MEASURE } from '../../constants/reading/MeasuresConstants';

const { MAZE, RAN, DO, AP, LC, RW, IW } = MEASURE;

const getClient = measure => {
    switch (measure) {
        case MAZE:
            return MAZEClient;
        case RAN:
            return RANClient;
        case DO:
            return DecodingClient;
        case AP:
        case LC:
        case RW:
        case IW:
            return DecodeClient;
        default:
            return sharedGetClient(measure, D8TranslatorClient);
    }
};

export default getClient;
